module.exports = __webpack_public_path__ + "static/media/mb-parsdc.59554212.png";